////////////////////////////////////////////////////////////////////////////////
//
// Edity api
//
////////////////////////////////////////////////////////////////////////////////

import {Action} from "@/store/actions";
import ApiService from "@/services/api.service";
import {Mutation} from "@/store/mutations";

const state = {
    entityConfig: null
}

////////////////////////////////////////////////////////////////////////////////

const actions = {
    async [Action.entity.loadConfig](context) {
        try {
            const result = await ApiService.entity.load()
            context.commit(Mutation.entityConfig.set, result.data.data)
        } catch (error) {
            context.commit(Mutation.notifyApiError, error)
            return Promise.reject(error)
        }
    },

    async [Action.entity.saveConfig](context, config) {
        try {
            await ApiService.entity.save(config)
            context.commit(Mutation.notify, {message: "Success", type: 'success'})
        } catch (error) {
            context.commit(Mutation.notifyApiError, error)
            return Promise.reject(error)
        }
    },
     async [Action.entity.uploadEntityFile](context, formData) {
        try {
            const result = await ApiService.entity.uploadEntityFile(formData);
            return result;
        } catch (error) {
 if (error.response?.data?.message?.includes('device_path')) {
        context.commit(Mutation.setError, 'Invalid device path format');
      } else {
        context.commit(Mutation.notifyApiError, error);
      }            return Promise.reject(error);
        }
    },
    async [Action.entity.uploadEntityFirmware](context, formData) {
    try {
      const result = await ApiService.entity.uploadEntityFirmware(formData);
      return result;
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  async [Action.entity.listEntityFiles](context, entityId) {
        try {
            const response = await ApiService.entity.listEntityFiles(entityId);
            return response.data;
        } catch (error) {
            context.commit(Mutation.notifyApiError, error);
            return Promise.reject(error);
        }
    },
    
    async [Action.entity.deleteEntityFile](context, fileId) {
        try {
            const response = await ApiService.entity.deleteEntityFile(fileId);
            return response.data;
        } catch (error) {
            context.commit(Mutation.notifyApiError, error);
            return Promise.reject(error);
        }
    },
     async [Action.entity.listEntityFirmware](context, entityId) {
    try {
      const response = await ApiService.entity.listEntityFirmware(entityId);
      return response.data;
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  
  async [Action.entity.deleteEntityFirmware](context, firmwareId) {
    try {
      const response = await ApiService.entity.deleteEntityFirmware(firmwareId);
      return response.data;
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  // Add these to your store actions
async [Action.entity.deleteAllEntityFiles](context, entityId) {
  try {
    const response = await ApiService.entity.deleteAllEntityFiles(entityId);
    return response.data;
  } catch (error) {
    context.commit(Mutation.notifyApiError, error);
    return Promise.reject(error);
  }
},

async [Action.entity.deleteAllEntityFirmware](context, { entityId, deviceType }) {
  try {
    const response = await ApiService.entity.deleteAllEntityFirmware(entityId, deviceType);
    return response.data;
  } catch (error) {
    context.commit(Mutation.notifyApiError, error);
    return Promise.reject(error);
  }
},
// ======== ICON ACTIONS ========
async [Action.entity.uploadEntityIcon](context, formData) {
    try {
        const result = await ApiService.entity.uploadEntityIcon(formData);
        return result;
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
},

async [Action.entity.listEntityIcons](context, entityId) {
    try {
        const response = await ApiService.entity.listEntityIcons(entityId);
        return response.data;
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
},

async [Action.entity.deleteEntityIcon](context, iconId) {
    try {
        const response = await ApiService.entity.deleteEntityIcon(iconId);
        return response.data;
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
},

async [Action.entity.deleteAllEntityIcons](context, entityId) {
    try {
        const response = await ApiService.entity.deleteAllEntityIcons(entityId);
        return response.data;
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
}
}

////////////////////////////////////////////////////////////////////////////////

const mutations = {
    [Mutation.entityConfig.set](state, entityConfig) {
        state.entityConfig = entityConfig;
    }
}

////////////////////////////////////////////////////////////////////////////////

const entity = {
    state: state,
    actions: actions,
    mutations: mutations,

}
export default entity